var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"z-card"},[_c('b-card',{class:{ 'z-clickable': !_vm.disabled, 'selected': !_vm.disabled && _vm.selected, 'disabled': _vm.disabled }},[_vm._t("default")],2)],1)}
var staticRenderFns = []

export { render, staticRenderFns }